/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { StakeholderDTO } from './StakeholderDTO';
import {
    StakeholderDTOFromJSON,
    StakeholderDTOFromJSONTyped,
    StakeholderDTOToJSON,
} from './StakeholderDTO';

/**
 * 
 * @export
 * @interface StakeholderPageDTO
 */
export interface StakeholderPageDTO {
    /**
     * 
     * @type {Array<StakeholderDTO>}
     * @memberof StakeholderPageDTO
     */
    content?: Array<StakeholderDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof StakeholderPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StakeholderPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StakeholderPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof StakeholderPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof StakeholderPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof StakeholderPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof StakeholderPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof StakeholderPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the StakeholderPageDTO interface.
 */
export function instanceOfStakeholderPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StakeholderPageDTOFromJSON(json: any): StakeholderPageDTO {
    return StakeholderPageDTOFromJSONTyped(json, false);
}

export function StakeholderPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StakeholderPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(StakeholderDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function StakeholderPageDTOToJSON(value?: StakeholderPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(StakeholderDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

